<template>
  <div class="upload">
    <kendo-upload ref="uploadRef"
                  name="files"
                  :multiple="multiple"
                  :show-file-list="false"
                  :async-auto-upload="false"
                  :async-chunk-side="true"
                  :async-chunk-size="chunkSize"
                  :localization-select="'파일 선택'"
                  @select="onSelectFile"
                  :validation-allowed-extensions='allowedExtensions'
    >
    </kendo-upload>

    <slot :name="'file-list'">
      <div class="k-upload" v-show="file !== []">
        <ul class="k-upload-files k-reset" style="width: 100%">
          <li v-bind:id="imageName+index" class="k-file" v-for="(fileItem,index) in file">
            <span class="k-progress" style="width: 100%;"></span>
            <span class="k-file-name-size-wrapper" style="margin-left:0!important;">
            <span class="k-file-name" style="margin-left:0!important;">{{ fileItem.name }}</span>
            <span class="k-file-size" style="margin-left:0!important;"  v-if="fileItem.size !== undefined">{{ Math.round(0.001 * parseInt(fileItem.size)) }} KB</span>
          </span>
            <strong class="k-upload-status">
              <button type="button" class="k-button k-upload-action" aria-label="Remove" @click="removeExistFiles(fileItem, index)">
                <span class="k-icon k-i-close k-i-x" title="Remove"></span>
              </button>
            </strong>
          </li>
        </ul>
      </div>
    </slot>
  </div>
</template>

<script>
import ApiUtil from '@/api/api.util'

export default {
  name: 'VersionFileUpload',
  model: {
    prop: 'file',
    event: 'change'
  },
  props: {
    downloadDomain : {
      type : String,
      default: ''
    },
    oldFileId : {
      type : String
    },
    file: {
      type: Array,
      default: function () {
        return []
      }
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    maxfile : { /// 파일 개수
      type: Number,
      default: 10
    },
    maxfileSizeMb : {
      type: Number,
      default: 500 /// 500MB 기준
    },
    chunkSize : {
      type: Number,
      default: 1024 * 1024 /// 1MB
    },
    imageName: {
      type: String,
      default: null,
    },
    allowedExtensions: {
      type: Array,
      default: function () {
        return [".exe"]
        // return [".gif", ".jpg", ".png", ".pdf", ".xlsx" ,".xls",".docx",".doc",".hwp",".txt",".pptx",".ppt", "jfif", ".exe"]
      }
    },
  },
  methods: {
    onSelectFile: function (e) {
      const vm = this
      const files = e.files

      //this.file.length + files.length -> 업로드한 파일개수와 업로드 하려고한 파일의 갯수의 합
      if (this.file.length + files.length > this.maxfile){
        kendo.alert(`파일은 최대 ${this.maxfile}개까지 업로드 할 수 있습니다.`)
        return false
      }

      // 확장자 체크
      let fileSpliceIndex = -1
      let fileIndex = this.file.length
      files.forEach((file, i) => {
        //첨부파일이 한페이지에 여러개를 삽입 할때는 imageName을 받아서 처리한다
        if (vm.imageName !== null) {
          file.imageName = vm.imageName
          file.seq = fileIndex
        }
        //허용 확장자 Array
        const allowedExtArray = vm.$refs.uploadRef.kendoWidget().options.validation.allowedExtensions
        if (!allowedExtArray.includes(file.extension.toLowerCase())) {
          // 불허 확장자 파일 index
          fileSpliceIndex = files.indexOf(file)

          kendo.alert(file.extension + '파일은 선택하실 수 없습니다.')
          e.preventDefault()
          return false
        } else if (file.size === 0) {
          fileSpliceIndex = 1
          kendo.alert('파일의 size가 0입니다 파일을 확인해 주세요.')
          e.preventDefault()
          return false
        } else if(file.size > vm.maxfileSizeMb * 1000000){
          fileSpliceIndex = 1
          kendo.alert(`파일의 size가 ${vm.maxfileSizeMb}MB보다 작은 파일을 선택해주세요.`)
          e.preventDefault()
          return false
        } else {
          fileIndex++
        }

        const fileInfo = file;

        setTimeout(function () {
          const raw = fileInfo.rawFile;
          const reader = new FileReader();
          const name = fileInfo.name
          const w = this

          if (raw) {
            reader.onloadend = function () {
              vm.$set(files[i], 'src', this.result)
            };
            reader.readAsDataURL(raw);
          }
        })
      })

      if (fileSpliceIndex < 0) {
        files.forEach((file, i) => {
          vm.file.push(file)
        })
      }
    },

    removeExistFiles: function (fileItem, idx) {
      if(!fileItem.rawFile){
        this.delSeqNo.push(fileItem.fileSeqNo)
      }
      this.file.splice(idx, 1)
    },

  },
  data () {
    return {
      delSeqNo : [],
      chunkFile: [],
    }
  },
}
</script>
<style>
.upload span.k-file-extension {
    font-size: 10px !important;
}
</style>
